import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className="flex flex-1 items-center justify-center px-4 py-20">
        <div className="flex w-full max-w-xl flex-col items-center text-center">
          <span className="font-heading text-[100px] font-black leading-none text-primary-200 md:text-[140px]">
            404
          </span>
          <h1 className="mt-2 font-heading text-2xl font-bold text-foreground-950">这个页面走丢了</h1>
          <p className="mt-3 text-sm text-foreground-500">
            你访问的路径 <span className="font-mono text-foreground-700">{location.pathname}</span> 不存在或已被移动。
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Link
              to="/"
              className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
            >
              <i className="ri-home-4-line" />
              返回首页
            </Link>
            <Link
              to="/news"
              className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-3 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer"
            >
              浏览动漫资讯
            </Link>
            <Link
              to="/recommendations"
              className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-3 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer"
            >
              浏览作品推荐
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}